export const setTokenWithExpiry = (token) => {
  const now = new Date().getTime();
  const expiryTime = now + 24 * 60 * 60 * 1000; // 24 hours
  localStorage.setItem("superAdminToken", token);
  localStorage.setItem("superAdminTokenExpiry", expiryTime.toString());
};

export const getTokenWithExpiry = () => {
  const token = localStorage.getItem("superAdminToken");
  const expiry = localStorage.getItem("superAdminTokenExpiry");

  if (!token || !expiry) return null;

  if (new Date().getTime() > parseInt(expiry)) {
    localStorage.removeItem("superAdminToken");
    localStorage.removeItem("superAdminTokenExpiry");
    return null;
  }

  return token;
};

export const clearToken = () => {
  localStorage.removeItem("superAdminToken");
  localStorage.removeItem("superAdminTokenExpiry");
};
